<script setup lang="ts">
definePage({
  meta: {
    id: 'vgco',
    title: 'Vegco',
    icon: 'mdi-cart-outline',
    drawerIndex: 5,
    breadcrumb: 'disabled',
    requiresAuth: true,
    requiresSiteAccess: 'vegco'
  },
})
</script>
<template>
  <RouterWrapper />
</template>
